import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { InputGeneric } from '../../../Forms/InputGeneric'
import { InputDate } from '../../../Forms/InputDate'
import { MainLoader } from '../../../loaders/mainLoader'
import { Logo } from '../../../Logo' 
import { Button } from '../../../Button'
import { api } from '../../../../services/api'
import { toast } from 'react-toastify'
import moment from 'moment'

import { Container } from './style'


export function RecoverByCPF() {
    const [cpf, setCpf] = useState('')
    const [date, setDate] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const history = useHistory()

    async function handleSendCPF(event) {
        event.preventDefault()
        setIsLoading(true)

        const obj = { 
            cpf, 
            date: moment(date).format('YYYY-MM-DD')
        }

        await api.post('/recoverByCPF', obj)
        .then(response => {
            const { token, success } = response.data

            if(success)
                history.push(`/password/${token}`)
            else
                toast.error('Usuário não encontrado')
        })
        .catch(() => {
            toast.error('Algo deu errado, tente novamente')

            return
        })
        .finally(() => {
            setIsLoading(false)
        })
    }


    return (
        <Container>
            <form onSubmit={handleSendCPF}>
                <Logo />

                <InputGeneric 
                    placeholder="Digite seu CPF"
                    value={cpf}
                    onChange={event => setCpf(event.target.value)}
                />

                <label>
                    Data de nascimento:
                </label>
                <InputDate 
                    type="date"
                    name="date"
                    className="inputDate"
                    value={date}
                    onChange={event => setDate(event.target.value)}
                />

                <Button>
                    Enviar
                </Button>
            </form>

            {
                isLoading 
                ? <MainLoader title={"Verificando..."}/> 
                : <></>
            } 
        </Container>
    )
}